export default __webpack_public_path__ + "app/images/theme-images/shared/ic-18-arrow-down.svg";